<div [formGroup]="form" class="ovrrride-flange-input-wrap">
    <mat-label class="font-style" [ngbTooltip]="minGasketStress" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Min Gasket Stress -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.MIN_GASKET_STRESS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #minGasketStress>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.MIN_GASKET_STRESS' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->

    <div class="example-checkbox" [ngClass]="form.get('minGasketStress').valid ? '' : 'highLight'">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" name="resultOptionEl" formControlName="isMinGasketStress"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input matInput formControlName="minGasketStress" name="mingasket_stress" [readonly]="!form.get('isMinGasketStress').value" />
        </mat-form-field>
    </div>
</div>
